/** @jsxImportSource theme-ui */
import { FormattedText } from "@bottlebooks/gatsby-design-system";
import { Trans } from "@lingui/macro";
import { FragmentType, graphql, useFragment } from "~/gql";
import Section from "../Section/Section";

const fragment = graphql(`
  fragment ProductPairingDescription on Product {
    pairingDescription
  }
`);

export default function ProductPairingDescription({
  data,
  ...rest
}: {
  data: FragmentType<typeof fragment>;
}) {
  const product = useFragment(fragment, data);
  if (!product?.pairingDescription) return null;
  return (
    <Section title={<Trans>Food Pairing</Trans>} {...rest}>
      <FormattedText variant="large" text={product.pairingDescription} />
    </Section>
  );
}
